import React from 'react'

import Loader from './Loader'

export type Props = React.SVGProps<SVGSVGElement> & {
  /** True if the overlay is open. */
  isOpen: boolean
  /** Optional description to render underneath the loader */
  description?: string
}

/** Full page loader that renders a semi-opaque overlay with a
 * loading indicator within it, in order to avoid unwanted clicks on screen.
 */
const FullPageLoader = ({ isOpen, description, ...loaderProps }: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50" data-testid="fullPageLoader">
      <div className="absolute inset-0 bg-white opacity-20 dark:bg-gray-900"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <Loader {...loaderProps} />
        <span className="sr-only">Loading...</span>
        {description && <p>{description}</p>}
      </div>
    </div>
  )
}

FullPageLoader.defaultProps = {
  width: 150,
  height: 150,
}

export default FullPageLoader
